import layout from './ONVStatisticView.html?raw';

import {
    View,
    ComponentManager,
} from 'radpresentation.htmlclient.defaultviewextensions';

export default class ONVStatisticView extends View {
    private view: JQuery<HTMLElement>;

    public constructor(private viewModel: any, private element?: JQuery<HTMLElement>) {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, layout);

        return this.view;
    }
}

ComponentManager.setView('ONVStatisticView', ONVStatisticView, 'ONVHTMLViewExtension');